module.exports = __webpack_public_path__ + "media/images/icon__arrow-left--rb-light-gray@3x-d764ab8d3f427efa7de023da92c7715d.png";